var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationRinging(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5226 4.51692C11.2455 3.91568 8.89637 5.2793 8.27551 7.56263C8.04156 8.42303 8.01631 9.16166 7.11225 10.5789C6.77939 11.1006 5.74122 12.0638 4.67067 12.9884C3.50916 13.9916 3.92008 15.9027 5.41198 16.2966C8.46453 17.1026 11.517 17.9087 14.5696 18.7147C16.0615 19.1086 17.387 17.656 16.8902 16.2149C16.4322 14.8866 16.0218 13.541 15.9983 12.9252C15.9344 11.2524 16.2873 10.6003 16.5212 9.7399C17.1422 7.45656 15.7996 5.11815 13.5226 4.51692ZM13.5226 4.51692L13.8879 3.17325M5.96821 7.01961C6.47764 5.14609 7.85407 3.7169 9.59571 3M17.693 5.13806C18.8375 6.61704 19.3044 8.53295 18.795 10.4065M13.6268 18.4658L13.5051 18.9136C13.0208 20.6946 11.5534 21.2786 10.0473 20.8809C8.5412 20.4832 7.5667 19.2545 8.05098 17.4735L8.17276 17.0256",
    stroke: "#F2F5F8",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationRinging);
export default __webpack_public_path__ + "static/media/notification-ringing.ecd710f11e5d5bcf7b6a754909795854.svg";
export { ForwardRef as ReactComponent };